import React from 'react';
import { Button } from 'react-bootstrap';
import Header from '../layouts/header';
import Footer from '../layouts/footer';
import { Link } from 'react-router-dom/dist';

export default function Home() {
  const d = new Date();
  const endTime = d.toLocaleString([], {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZone: 'Asia/Dhaka',
  });

  return (
    <div className="container-fluid p-0">
      <Header />

      <main className="container root">
        <div className="row gy-4">
          <div className="col-12">
            <div className="card card-modern p-4">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="mb-1">Good day</h4>
                  <p className="small text-muted mb-0">Welcome back — here's a quick summary of your day</p>
                </div>
                <div className="text-end">
                  <div className="small-muted">Local time</div>
                  <div className="h5 mb-0 text-dark">{endTime}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <Link to="/attendance" className="text-decoration-none">
              <div className="card card-modern h-100 action-card">
                <div className="card-body d-flex align-items-center">
                  <div className="me-3 display-icon bg-light">
                    <i className="fa-solid fa-right-to-bracket text-brand fa-2x"></i>
                  </div>
                  <div>
                    <h6 className="mb-1 text-dark">Attendance</h6>
                    <p className="small text-muted mb-0">Check in / out and view today's status</p>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <Link to="/leaves" className="text-decoration-none">
              <div className="card card-modern h-100 action-card">
                <div className="card-body d-flex align-items-center">
                  <div className="me-3 display-icon bg-light">
                    <i className="fa-solid fa-calendar-check text-brand fa-2x"></i>
                  </div>
                  <div>
                    <h6 className="mb-1 text-dark">Leave</h6>
                    <p className="small text-muted mb-0">Apply for leave or view leave balance</p>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <Link to="/notice" className="text-decoration-none">
              <div className="card card-modern h-100 action-card">
                <div className="card-body d-flex align-items-center">
                  <div className="me-3 display-icon bg-light">
                    <i className="fa-solid fa-bell text-brand fa-2x"></i>
                  </div>
                  <div>
                    <h6 className="mb-1 text-dark">Notices</h6>
                    <p className="small text-muted mb-0">Latest company announcements</p>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <Link to="/phonebook" className="text-decoration-none">
              <div className="card card-modern h-100 action-card">
                <div className="card-body d-flex align-items-center">
                  <div className="me-3 display-icon bg-light">
                    <i className="fa-solid fa-address-book text-brand fa-2x"></i>
                  </div>
                  <div>
                    <h6 className="mb-1 text-dark">Phonebook</h6>
                    <p className="small text-muted mb-0">Find colleagues and departments</p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
